import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PvrCookieEncryptionService {
    private readonly httpClient = inject(HttpClient);


    /**
     * Encrypts a token to generate a PVR cookie.
     * 
     * @param token - The token to be encrypted for the PVR cookie
     * @returns Observable<any> - The encrypted cookie data
     * 
     * @remarks
     * This API is used to create a secure encrypted cookie that allows redirecting
     * users after completing certain flows while maintaining authentication state.
     */
    encryptPvrCookie(token: string): Observable<any> {
        const url = `${environment.ZCI_API_BASE_URL}${environment.ZCI_API_ENDPOINTS.PVR_COOKIE_ENCRYPTION}`;
        return this.httpClient.post(url, { token });
    }
}
